import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckSquare, ArrowRight } from "@phosphor-icons/react";
import { PageHero } from "../components/PageHero";
import { CTASection } from "../components/home/CTASection";
import { useServices } from "../lib/api";

export default function ServicesPage() {
  const { data: services = [] } = useServices();

  return (
    <div data-testid="services-page">
      <PageHero
        overline="Capabilities"
        title="Premium services. Engineered delivery."
        subtitle="Construction, renovation, restoration, redevelopment, and government services — self-performed and managed with precision."
      />

      <section className="bg-canvas">
        {services.map((svc, i) => (
          <div key={svc.id} className={`border-b border-line ${i % 2 === 1 ? "bg-panel" : ""}`}>
            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.55 }}
                className={i % 2 === 1 ? "lg:order-2" : ""}
              >
                <p className="overline-label mb-3">0{svc.order} — {svc.slug.replace(/-/g, " ")}</p>
                <h2 className="font-heading font-medium text-3xl md:text-4xl tracking-tight text-ink">{svc.name}</h2>
                <p className="mt-2 font-mono-tech text-xs tracking-wider text-blueprint">{svc.tagline}</p>
                <p className="mt-5 text-sub leading-relaxed">{svc.description}</p>
                <ul className="mt-7 space-y-3">
                  {(svc.features || []).map((f) => (
                    <li key={f} className="flex items-start gap-3 text-sm text-ink">
                      <CheckSquare size={17} className="text-blueprint mt-0.5 shrink-0" weight="fill" />
                      {f}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/quote"
                  data-testid={`service-quote-link-${svc.slug}`}
                  className="mt-8 inline-flex items-center gap-2 text-sm font-medium text-blueprint hover:gap-3 transition-all"
                >
                  Request a quote for {svc.name.toLowerCase()} <ArrowRight size={15} />
                </Link>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, scale: 0.98 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.6 }}
                className={i % 2 === 1 ? "lg:order-1" : ""}
              >
                <img src={svc.image} alt={svc.name} className="w-full h-72 md:h-96 object-cover border border-line" />
              </motion.div>
            </div>
          </div>
        ))}
      </section>

      <CTASection />
    </div>
  );
}
